import script from "./EventiProgrammi.vue?vue&type=script&setup=true&lang=js"
export * from "./EventiProgrammi.vue?vue&type=script&setup=true&lang=js"

import "./EventiProgrammi.vue?vue&type=style&index=0&id=fb929ba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb929ba8"]])

export default __exports__